import { useMemo } from 'react';
import { useDashboardShell } from '../context/DashboardShellContext';
import {
  batchRootPath,
  batchAssignmentsPath,
  batchAssignmentPath,
  batchAssignmentProgressPath,
  batchProgressPath,
  batchStudentsPath,
} from '../utils/codingPaths';

/**
 * Frontend paths for the coding tracker, respecting `/admin` vs `/faculty` layout prefix.
 */
export function useCodingRoutes() {
  const shell = useDashboardShell();
  const codingRoot = shell?.codingRoot ?? null;

  return useMemo(() => {
    if (!codingRoot) {
      return {
        codingRoot: null,
        trackerHome: '/coding-tracker',
        batch: (batchId) => `/batch/${batchId}`,
        assignments: (batchId) => `/batch/${batchId}/assignments`,
        assignment: (batchId, assignmentId) => `/batch/${batchId}/assignments/${assignmentId}`,
        assignmentProgress: (batchId, assignmentId) =>
          `/batch/${batchId}/assignments/${assignmentId}/progress`,
        progress: (batchId) => `/batch/${batchId}/progress`,
        students: (batchId) => `/batch/${batchId}/students`,
      };
    }
    return {
      codingRoot,
      trackerHome:
        codingRoot === '/faculty' ? `${codingRoot}/coding-dashboard` : `${codingRoot}/coding-tracker`,
      batch: (batchId) => batchRootPath(codingRoot, batchId),
      assignments: (batchId) => batchAssignmentsPath(codingRoot, batchId),
      assignment: (batchId, assignmentId) =>
        batchAssignmentPath(codingRoot, batchId, assignmentId),
      assignmentProgress: (batchId, assignmentId) =>
        batchAssignmentProgressPath(codingRoot, batchId, assignmentId),
      progress: (batchId) => batchProgressPath(codingRoot, batchId),
      students: (batchId) => batchStudentsPath(codingRoot, batchId),
    };
  }, [codingRoot]);
}
